<template>
  <a @click="toggleMenu">
    <span class="fa-stack fa-2x">
      <i class="far fa-circle fa-stack-2x "></i>
      <i :class="faClasses"></i>
    </span>
  </a>
</template>

<script>
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  mixins: [formatter],
  methods: {
    toggleMenu () {
      this.$store.commit('mobileMenu/' + this.getMutation())
    },
    getMutation () {
      if (this.$store.state.mobileMenu.isShown) {
        return 'hide'
      } else {
        return 'show'
      }
    }
  },
  computed: {
    faClasses () {
      let ret = 'fas fa-stack-1x fa-'

      if (this.$store.state.mobileMenu.isShown) {
        ret += 'times'
      } else {
        ret += 'bars'
      }

      return ret
    }
  }
}
</script>
